import moment from 'moment-timezone'

const getBRDate = ( ISODate ) => {
  const date = new moment(ISODate).tz("America/Sao_Paulo");
  let dateString = date.format( 'DD/MM/YY' )
  return dateString
}

const getBRDateTime = ( ISODate ) => {
  const date = new moment(ISODate).tz("America/Sao_Paulo");
  let dateString = date.format( 'DD/MM/YY' )
  return dateString
}


export {
  getBRDate, getBRDateTime
}


// WEBPACK FOOTER //
// ./src/utils/DateUtils.js